import {Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from "@angular/core";
import {CustomEqualitySet} from "custom-equality-set";
import * as _ from "lodash";
import {Money} from "money";
import {CartService} from "purchasing-shared/cart.service";
import {contextPath, fgURL} from "site";
import {Aircraft} from "../aircraft";
import {AvdbBundleCartItem} from "../avdb-bundle-cart-item";
import {AvdbCartItem} from "../avdb-cart-item";
import {Message} from "../common/message";
import {Device} from "../device";
import {DeviceModel} from "../device-model";
import {DeviceService} from "../device.service";
import {AvdbPricingAircraftBundle} from "./avdb-pricing-aircraft-bundle";
import {AvdbPricingBundle} from "./avdb-pricing-bundle";
import {AvdbPricingBundlePackage} from "./avdb-pricing-bundle-package";
import {AvdbPricingDeviceBundle} from "./avdb-pricing-device-bundle";
import {AvdbPricingProduct} from "./avdb-pricing-product";
import {AvdbPricingResponse} from "./avdb-pricing-response";
import {KeepShoppingModalComponent} from "./keep-shopping-modal.component";
import {CartItem} from "../../purchasing/cart/cart-item";
import {Observable} from "rxjs";
import {AvdbPricingMapRegion, AvdbPricingMapRegionID} from "./avdb-pricing-map-region";
import {AvdbSubscriptionService} from "../avdb-subscription.service";
import {AvdbSubscription} from "../avdb-subscription";

const FLITECHARTS_AVDB_TYPE_ID = 5;

@Component({
	selector: "bundles-list",
	template: `

		<!---------- NOTE EXPLAINING BUNDLES TAB ---------->
		<p class="segmentedtab_info">
			<i class="fa fa-info-circle fa-lg"></i>
			This tab presents all available
			<a target="_blank" href="{{ onepakPilotpakFaqUrl }}" title="Learn more about OnePaks">OnePaks <i class="fa fa-question-circle"></i></a>,
			<a target="_blank" href="{{ onepakPilotpakFaqUrl }}" title="Learn more about PilotPaks">PilotPaks <i class="fa fa-question-circle"></i></a>,
			and device-specific Database Bundles based on your selected aircraft and devices.
			To narrow down this list, select one of the filter options below.
		</p>

		<div class="databasepricing_selection_sections">

			<!---------- SELECT A FILTER ---------->
			<div class="databasepricing_selection_section">
				<h3>Filter <small class="databasepricing_headingsubtext">(Select one)</small></h3>

				<ul class="databasepricing_selection_list">

					<!---------- ALL BUNDLES ---------->
					<li (click)="selectAllBundlesFilter()"
						[class.active]="selectedFilter === ALL_BUNDLES">
						All Bundles ({{ allBundles.length }})
					</li>

					<!---------- ONEPAKS ---------->
					<li *ngIf="onePakBundles.length > 0"
						(click)="selectOnePaksFilter()"
						[class.active]="selectedFilter === ONEPAKS">
						OnePaks ({{ onePakBundles.length }})
					</li>

					<!---------- PILOTPAKS ---------->
					<li *ngIf="pilotPakBundles.length > 0"
						(click)="selectPilotPaksFilter()"
						[class.active]="selectedFilter === PILOTPAKS">
						PilotPaks ({{ pilotPakBundles.length }})
					</li>

					<!---------- DEVICE BUNDLES ---------->
					<ng-container *ngFor="let device of avdbPricingResponse.devices">
						<li *ngIf="getDeviceBundlesForDeviceID(device.id).length > 0"
							(click)="selectDeviceBundlesFilterForDeviceID(device.id)"
							[class.active]="selectedFilter === device.id.toString()">
							{{ duplicateDeviceNames.has(device.name) ? device.name + ' (' + device.displaySerial + ')' : device.name }}
							Bundles ({{ getDeviceBundlesForDeviceID(device.id).length }})
						</li>
					</ng-container>

				</ul>
			</div>

		</div>

		<!---------- BUNDLE PACKAGES ---------->
		<div class="databasepricing_recommendedbundles_list" *ngIf="bundlePackages.length > 0">
			<ng-container *ngFor="let bundlePackage of bundlePackages">
				<div class="databasepricing_row">
					<div class="databasepricing_row_column">

						<!---------- BUNDLE PACKAGE - INCLUDED BUNDLES ---------->
						<div class="databasepricing_recommendedbundles_info">
							<h4 *ngFor="let bundle of bundlePackage.bundles"
								class="databasepricing_recommendedbundles_info_bundle">
								{{ bundle.description }}
								<span *ngIf="getDeviceNameForBundle(bundle)"
									  class="databasepricing_recommendedbundles_info_device">
									- {{ getDeviceNameForBundle(bundle) }}
								</span>
								<span *ngIf="bundlePackage.shouldDisplayIndividualPrices"
									  class="databasepricing_recommendedbundles_info_cost">
									- {{ bundle.price | money }}
								</span>
							</h4>
							<div *ngFor="let device of bundlePackage.getDevicesCoveredByAdditionalProducts()">
								<h4 *ngFor="let product of bundlePackage.getAdditionalProductsForDevice(device)"
									class="databasepricing_recommendedbundles_info_bundle">
									{{ product.productType.name }} -
									<span *ngFor="let series of product.series; let i = index;">
										{{ series.region.displayName }}{{ (i < product.series.length - 1) ? ", " : "" }}
									</span>
									<span class="databasepricing_recommendedbundles_info_device">
										- {{ device.name }}
									</span>
									<span class="databasepricing_recommendedbundles_info_cost">
										- {{ product.price | money }}
									</span>
								</h4>
							</div>
							<a class="databasepricing_recommendedbundles_coveragelink"
							   (click)="coverageModal.open(bundlePackage)">
								View Coverage Details
							</a>
							<ng-container *ngFor="let message of getCoverageMessages(bundlePackage)">
								<avdb-message [message]="message"></avdb-message>
							</ng-container>
						</div>

					</div>
					<div class="databasepricing_row_column">

						<!---------- BUNDLE PACKAGE - PRICE AND SELECT BUTTON ---------->
						<div class="databasepricing_row_group">
							<div class="databasepricing_row_price" *ngIf="activeSubscriptionsLoaded && (bundlePackage | flyIsBundleActiveForAircraftOrDevice:  activeSubscriptions) as subscriptionStatus">
								<div *ngIf="!subscriptionStatus.isPurchased">
									{{ bundlePackage.price | money }}
								</div>
							</div>
							<div>
								<ng-container
									*ngIf="activeSubscriptionsLoaded && (bundlePackage | flyIsBundleActiveForAircraftOrDevice:  activeSubscriptions) as subscriptionStatus">
									<div class="active-subscription" *ngIf="subscriptionStatus.isPurchased; else addToCartButton" >
										<div class="redeem-subscription" *ngIf="!subscriptionStatus.isRedeemed">
											<span class="unredeemed-subscription">You have an unredeemed subscription.</span>
											<a target="_blank" href="{{navigateToDetails(subscriptionStatus.isAircraftBundle)}}"
											   class="button button-primary">
												Redeem Now
											</a>
										</div>
										<div class="manage-subscription" *ngIf="subscriptionStatus.isRedeemed">
											<span *ngIf="!subscriptionStatus.autoRenewActive">You have an active subscription that <strong>expires</strong> on {{ subscriptionStatus.endDate }}.</span>
											<span *ngIf="subscriptionStatus.autoRenewActive">You have an active subscription that <strong>automatically renews</strong> on {{ subscriptionStatus.renewalDate }}.</span>
											<a target="_blank" href="{{fgURL + 'subscriptions/databases/'}}"
											   class="button button-primary">
												Manage Subscription
											</a>
										</div>
									</div>
								</ng-container>
								<ng-template #addToCartButton>
									<div>
										<ng-container
											*ngIf="loadingAddToCart && (bundlePackage | flyIsBundlePackageAlreadyInCartForAircraft: selectedAircraft: currentCart)  || (bundlePackage | flyIsBundlePackageAlreadyInCartForAircraft: selectedAircraft: currentCart); else addToCart">
											<i class="fa fa-check"></i>
											<span class="bold-text">
											ADDED TO CART
										</span>
										</ng-container>
										<ng-template #addToCart>
											<button class="button button-secondary"
													(click)="addBundlePackageToCart(bundlePackage)">
												Add to Cart
											</button>
										</ng-template>
									</div>
								</ng-template>
							</div>
						</div>

					</div>
				</div>
			</ng-container>
		</div>

		<div class="databasepricing_nobundlesmatchingregions"
			 *ngIf="bundlePackages.length == 0 && onlyShowBundlesForSelectedRegions == true">
			There are no {{ filterName }} available that cover all of your selected regions. Select <strong>View All
			Available {{ capitalizedFilterName }}</strong> below to see our
			catalog of all available bundles for your devices.
		</div>

		<div *ngIf="onlyShowBundlesForSelectedRegions == true" class="databasepricing_expand_button">
			<button type="button" class="button-link" (click)="updateOnlyShowBundlesForSelectedRegions(false)">
				<i class="fa fa-caret-down"></i> View All Available {{ capitalizedFilterName }}
			</button>
		</div>

		<div *ngIf="onlyShowBundlesForSelectedRegions == false" class="databasepricing_expand_button">
			<button type="button" class="button-link" (click)="updateOnlyShowBundlesForSelectedRegions(true)">
				<i class="fa fa-caret-up"></i> View {{ capitalizedFilterName }} Only for Selected Regions
			</button>
		</div>

		<!---------- COVERAGE DETAIL MODAL ---------->
		<bundle-package-coverage-detail #coverageModal
										[devices]="allSelectedDevices"
										[bundleToDevicesMap]="filteredBundleToCoveredDevicesMap"
										[partKeyProductMap]="partKeyProductMap"></bundle-package-coverage-detail>

		<!---------- KEEP SHOPPING MODAL ---------->
		<keep-shopping-modal (continueShopping)="updateCart()"></keep-shopping-modal>
	`,
})
export class BundlesListComponent implements OnChanges, OnInit {
	readonly ALL_BUNDLES = "ALL_BUNDLES";
	readonly ONEPAKS = "ONEPAKS";
	readonly PILOTPAKS = "PILOTPAKS";
	readonly contextPath = contextPath;
	readonly fgURL = fgURL;

	@Input() selectedAircraft: Aircraft;
	@Input() currentCart: CartItem[] | null = null;
	@Input() selectedPortable: Device;
	@Input() avdbPricingResponse: AvdbPricingResponse;
	@Input() partKeyProductMap: Map<string, AvdbPricingProduct>;
	@Input() selectedMapRegions: Set<AvdbPricingMapRegionID>;
	@Output() bundleAddedToCart = new EventEmitter();
	@Output() continueShopping = new EventEmitter();
	@ViewChild(KeepShoppingModalComponent) keepShoppingModal: KeepShoppingModalComponent;

	deviceModels: Array<DeviceModel> = [];
	allBundles: Array<AvdbPricingBundle> = [];
	onePakBundles: Array<AvdbPricingAircraftBundle> = [];
	pilotPakBundles: Array<AvdbPricingAircraftBundle> = [];
	bundlePackages: Array<AvdbPricingBundlePackage> = [];
	selectedFilter = this.ALL_BUNDLES;
	filteredBundleToCoveredDevicesMap = new Map<AvdbPricingBundle, Array<Device>>();
	duplicateDeviceNames: Set<string> = new Set<string>();
	onlyShowBundlesForSelectedRegions: boolean = true;

	filterName: string = 'bundles';
	capitalizedFilterName: string = 'Bundles';

	loadingAddToCart: boolean = false;

	bundleListCart: CartItem[] | null = null;

	shouldShowFliteCharts: boolean = false;

	onepakPilotpakFaqUrl: string;

	activeSubscriptions: AvdbSubscription[];

	activeSubscriptionsLoaded: boolean = false;

	constructor(private cartService: CartService,
				private deviceService: DeviceService,
				private avdbSubscriptionService: AvdbSubscriptionService,
				@Inject("onepakPilotpakFaqUrl") onepakPilotpakFaqUrl: string) {
		this.onepakPilotpakFaqUrl = onepakPilotpakFaqUrl;
	}

	ngOnInit() {
		this.deviceService.getDeviceModels().subscribe((deviceModels) => {
			this.deviceModels = deviceModels;
			this.calculateShouldShowFliteCharts();
			this.calculateBundlePackages();
		});

		this.refreshCurrentCart();
		this.getActiveSubscriptions();
	}

	ngOnChanges(changes: SimpleChanges) {
		this.calculateShouldShowFliteCharts();
		this.allBundles = this.getAllBundles();
		this.onePakBundles = this.getAllOnePakBundles();
		this.pilotPakBundles = this.getAllPilotPakBundles();
		this.selectAllBundlesFilter();
		this.duplicateDeviceNames = this.getDuplicateDeviceNames();

		if ("currentCart" in changes) {
			this.refreshCurrentCart();
		}

		if ("selectedAircraft" in changes || "selectedPortable" in changes) {
			this.getActiveSubscriptions();
		}
	}

	getActiveSubscriptions() {
		const getSelectedAircraftSubscriptions$ = (this.selectedAircraft == null || this.selectedAircraft.masterAircraftUuid == null)
			? Observable.of([]) :
			this.avdbSubscriptionService.getAvdbSubscriptions(null, this.selectedAircraft.masterAircraftUuid, null, false, true).catch(() => Observable.of([]));

		const getSelectedPortableSubscriptions$ = (this.selectedPortable == null || this.selectedPortable.displaySerial == null || this.selectedPortable.displaySerial === '')
			? Observable.of([]) :
			this.avdbSubscriptionService.getAvdbSubscriptions(null, null, this.selectedPortable.displaySerial, false, true).catch(() => Observable.of([]));

		Observable.forkJoin(
			getSelectedAircraftSubscriptions$,
			getSelectedPortableSubscriptions$
		).subscribe(([aircraftSubscriptions, portableSubscriptions]) => {
			this.calculateShouldShowFliteCharts();
			this.calculateBundlePackages();
			this.activeSubscriptions = aircraftSubscriptions.concat(portableSubscriptions);
			this.activeSubscriptionsLoaded = true;
		});
	}

	getDuplicateDeviceNames(): Set<string> {
		return new Set(
			this.selectedAircraft ?
				this.selectedAircraft.devices.map(d => d.name).sort().filter((device, currentIndex, devices) =>
					device == devices[currentIndex + 1]
				)
				: []
		);
	}

	// TODO: Duplicated from DatabasePricingComponent
	get allSelectedDevices(): Array<Device> {
		let devices: Array<Device> = [];
		if (this.selectedAircraft != null)
			devices.push(...this.selectedAircraft.devices.filter(device => device.hexSystemId == device.displaySerial));
		if (this.selectedPortable != null)
			devices.push(this.selectedPortable);
		return devices;
	}

	// TODO: Duplicated from BundleRecommendationComponent
	private populateFilteredBundleToCoveredDevicesMap() {
		this.filteredBundleToCoveredDevicesMap = new Map<AvdbPricingBundle, Array<Device>>();
		for (let bundle of this.getFilteredBundles()) {
			if (bundle instanceof AvdbPricingAircraftBundle) {
				const devices: Array<Device> = [];
				for (let deviceModel of bundle.qualifyingDeviceModels) {
					const registeredDevices = this.allSelectedDevices.filter(device => device.modelID === deviceModel.modelID);
					for (let registeredDevice of registeredDevices) {
						if (!devices.find(device => device.id === registeredDevice.id)) {
							devices.push(registeredDevice);
						}
					}
				}
				this.filteredBundleToCoveredDevicesMap.set(bundle, devices);
			} else {
				const device = this.allSelectedDevices.find(device => device.id === (bundle as AvdbPricingDeviceBundle).deviceID);
				if (device) {
					this.filteredBundleToCoveredDevicesMap.set(bundle, [device]);
				}
			}
		}
	}

	// ====================================================================================================
	// Device Models
	// ====================================================================================================

	// TODO: Duplicated from BundleRecommendationComponent
	getDeviceModel(deviceModelID: number): DeviceModel {
		return this.deviceModels.find(deviceModel => deviceModel.id === deviceModelID);
	}

	// TODO: Duplicated from BundleRecommendationComponent
	private isDeviceModelAnAircraftDevice(deviceModelID: number): boolean {
		const deviceModel = this.getDeviceModel(deviceModelID);
		if (deviceModel)
			return deviceModel.portable === false;
		else
			return false;
	}

	// ====================================================================================================
	// Filter Selections
	// ====================================================================================================

	selectAllBundlesFilter() {
		this.selectedFilter = this.ALL_BUNDLES;
		this.filterName = 'bundles';
		this.capitalizedFilterName = 'Bundles';
		this.calculateBundlePackages();
	}

	selectOnePaksFilter() {
		this.selectedFilter = this.ONEPAKS;
		this.filterName = 'OnePaks';
		this.capitalizedFilterName = 'OnePaks';
		this.calculateBundlePackages();
	}

	selectPilotPaksFilter() {
		this.selectedFilter = this.PILOTPAKS;
		this.filterName = 'PilotPaks';
		this.capitalizedFilterName = 'PilotPaks';
		this.calculateBundlePackages();
	}

	selectDeviceBundlesFilterForDeviceID(deviceID: number) {
		this.selectedFilter = deviceID.toString();
		this.filterName = 'device bundles';
		this.capitalizedFilterName = 'Device Bundles';
		this.calculateBundlePackages();
	}

	updateOnlyShowBundlesForSelectedRegions(onlyShowBundlesForSelectedRegions: boolean) {
		this.onlyShowBundlesForSelectedRegions = onlyShowBundlesForSelectedRegions;
		this.calculateBundlePackages();
	}

	// ====================================================================================================
	// Bundles
	// ====================================================================================================

	private getAllBundles(): Array<AvdbPricingBundle> {
		const bundles: Array<AvdbPricingBundle> = [];
		const onePakBundles: Array<AvdbPricingBundle> = [];

		for (let aircraftBundle of this.getAllOnePakBundles()) {
			onePakBundles.push(aircraftBundle);
		}

		for (let aircraftBundle of this.getAllPilotPakBundles()) {
			bundles.push(aircraftBundle);
		}

		for (let deviceBundle of this.getAllDeviceBundles()) {
			bundles.push(deviceBundle);
		}

		return [..._.sortBy(onePakBundles, bundle => bundle.description),
			..._.sortBy(bundles, bundle => bundle.description)
		];
	}

	private getFilteredBundles(): Array<AvdbPricingBundle> {
		switch (this.selectedFilter) {
			case this.ALL_BUNDLES:
				return this.allBundles;
			case this.ONEPAKS:
				return this.onePakBundles;
			case this.PILOTPAKS:
				return this.pilotPakBundles;
			default:
				return this.getDeviceBundlesForDeviceID(Number(this.selectedFilter));
		}
	}

	private filterBundlesByHelicopterFixedWingEligibility(bundle: AvdbPricingBundle): Boolean {
		if (bundle.helicopterEligible == null || bundle.fixedWingEligible == null) {
			return true;
		}

		if (this.selectedAircraft != null) {
			if (bundle instanceof AvdbPricingAircraftBundle) {
				if (this.selectedAircraft.isRotorcraft) {
					return bundle.helicopterEligible;
				} else if (this.onlyShowBundlesForSelectedRegions) {
					return bundle.fixedWingEligible;
				}
			} else {
				let deviceModelID = (bundle as AvdbPricingDeviceBundle).deviceModelID;
				const deviceModel = this.deviceModels ? this.deviceModels.find(deviceModel => deviceModel.id === deviceModelID) : null;
				let isDeviceBundleForAnAircraftDevice = deviceModel && deviceModel.portable === false;

				if (isDeviceBundleForAnAircraftDevice) {
					if (this.selectedAircraft.isRotorcraft) {
						return bundle.helicopterEligible;
					} else if (this.onlyShowBundlesForSelectedRegions) {
						return bundle.fixedWingEligible;
					}
				}
			}
		}
		return true;
	}

	// ====================================================================================================
	// Aircraft Bundles (OnePaks and PilotPaks)
	// ====================================================================================================

	// TODO: Duplicated from BundleRecommendationComponent
	private getAllAircraftBundles(): Array<AvdbPricingAircraftBundle> {
		return this.avdbPricingResponse.aircraftBundles;
	}

	private getAllOnePakBundles(): Array<AvdbPricingAircraftBundle> {
		const onePakBundles = this.getAllAircraftBundles().filter(bundle => bundle.bundleType === AvdbPricingBundle.BUNDLE_TYPE_ONEPAK);
		return _.sortBy(onePakBundles, bundle => bundle.description);
	}

	private getAllPilotPakBundles(): Array<AvdbPricingAircraftBundle> {
		const pilotPakBundles = this.getAllAircraftBundles().filter(bundle => bundle.bundleType === AvdbPricingBundle.BUNDLE_TYPE_PILOTPAK);
		return _.sortBy(pilotPakBundles, bundle => bundle.description);
	}

	// ====================================================================================================
	// Device Bundles
	// ====================================================================================================

	// TODO: Duplicated from BundleRecommendationComponent
	private getAllDeviceBundles(): Array<AvdbPricingDeviceBundle> {
		const deviceBundles: Array<AvdbPricingDeviceBundle> = [];
		for (let device of this.avdbPricingResponse.devices) {
			deviceBundles.push(...device.bundles);
		}

		return deviceBundles;
	}

	private getDeviceBundlesForDeviceID(deviceID: number): Array<AvdbPricingDeviceBundle> {
		const deviceBundles = this.getAllDeviceBundles().filter(bundle => bundle.deviceID === deviceID);
		return _.sortBy(deviceBundles, bundle => bundle.description);
	}

	// TODO: Duplicated from BundleRecommendationComponent
	private isDeviceBundleForAnAircraftDevice(bundle: AvdbPricingDeviceBundle): boolean {
		return this.isDeviceModelAnAircraftDevice(bundle.deviceModelID);
	}

	// ====================================================================================================
	// Bundle Packages
	// ====================================================================================================

	private calculateBundlePackages() {
		this.bundlePackages = [];
		this.populateFilteredBundleToCoveredDevicesMap();

		let filteredBundles = this.getFilteredBundles();
		if (!this.shouldShowFliteCharts) {
			const bundlesWithoutFliteCharts = filteredBundles.filter((bundle) => !bundle.hasFliteCharts);
			filteredBundles = bundlesWithoutFliteCharts.length === 0 ? filteredBundles : bundlesWithoutFliteCharts;
		} else {
			filteredBundles = filteredBundles.filter((bundle) => !bundle.hasFliteCharts || Array.from(bundle.allAvdbTypes.values()).some(t => t.id === FLITECHARTS_AVDB_TYPE_ID));
		}

		for (let bundle of filteredBundles) {
			if (this.selectedAircraft == null || this.filterBundlesByHelicopterFixedWingEligibility(bundle)) {
				this.bundlePackages.push(new AvdbPricingBundlePackage(new CustomEqualitySet<AvdbPricingBundle>([bundle])));
			}
		}

		this.bundlePackages.forEach(bundlePackage => {
			this.calculateValueForBundlePackage(bundlePackage);
			this.calculateBundlePackageRank(bundlePackage);
		});

		this.bundlePackages = _.sortByOrder(Array.from(this.bundlePackages),
			[bp => bp.rank, bp => bp.price.value],
			["desc", "asc"]);

		if (this.onlyShowBundlesForSelectedRegions && this.bundlePackages.length > 0) {
			if (this.selectedFilter == this.ALL_BUNDLES) {
				const onePakBundlePackages: AvdbPricingBundlePackage[] = [];
				const pilotPakBundlePackages: AvdbPricingBundlePackage[] = [];
				const deviceBundlePackages: AvdbPricingBundlePackage[] = [];

				this.bundlePackages.forEach((bundlePackage) => {
					const packageBundles = Array.from(bundlePackage.bundles.values());
					if (packageBundles.some(bundle => bundle.bundleType == AvdbPricingBundle.BUNDLE_TYPE_ONEPAK)) {
						onePakBundlePackages.push(bundlePackage);
					} else if (packageBundles.some(bundle => bundle.bundleType == AvdbPricingBundle.BUNDLE_TYPE_DEVICE)) {
						deviceBundlePackages.push(bundlePackage);
					} else if (packageBundles.some(bundle => bundle.bundleType == AvdbPricingBundle.BUNDLE_TYPE_PILOTPAK)) {
						pilotPakBundlePackages.push(bundlePackage);
					}
				});

				const highestOnePakRank = onePakBundlePackages.length > 0 ? onePakBundlePackages[0].rank : 0;
				const highestPilotPakRank = pilotPakBundlePackages.length > 0 ? pilotPakBundlePackages[0].rank : 0;
				const highestDeviceBundleRank = deviceBundlePackages.length > 0 ? deviceBundlePackages[0].rank : 0;

				this.bundlePackages = _.union(
					onePakBundlePackages.filter((bundlePackage) => bundlePackage.rank == highestOnePakRank),
					pilotPakBundlePackages.filter((bundlePackage) => bundlePackage.rank == highestPilotPakRank),
					deviceBundlePackages.filter((bundlePackage) => bundlePackage.rank == highestDeviceBundleRank)
				);

				this.bundlePackages = _.sortByOrder(Array.from(this.bundlePackages),
					[bp => bp.rank, bp => bp.price.value],
					["desc", "asc"]);
			} else {
				const highestRank = this.bundlePackages[0].rank;
				// If the highest rank is less than the number of selected regions - 1 then there are no bundles that cover all
				// selected regions (rank is calculated as # of regions selected and covered - 0.1 * # of regions not selected and covered)
				if (highestRank > this.selectedMapRegions.size - 1) {
					this.bundlePackages = this.bundlePackages.filter((bundlePackage) => bundlePackage.rank == highestRank);
				} else {
					this.bundlePackages = [];
				}
			}
		}
	}

	private calculateBundlePackageRank(bundlePackage: AvdbPricingBundlePackage) {
		const allRegionIds = AvdbPricingMapRegion.regions.map(region => region.id);
		const selectedMapRegionIDs = Array.from(this.selectedMapRegions.values());
		let numberOfDevicesCovered = 0;
		for (let device of this.allSelectedDevices) {
			const bundle = bundlePackage.getBundleThatCoversDevice(device);
			if (bundle) {
				numberOfDevicesCovered += 1;
				for (let regionID of allRegionIds) {
					if (bundle.isMapRegionSupported(regionID)) {
						if (selectedMapRegionIDs.includes(regionID)) {
							bundlePackage.increaseRank(AvdbPricingBundlePackage.RANK_INCREASE_FOR_MAP_COVERAGE_REGION);
						} else {
							bundlePackage.decreaseRank(AvdbPricingBundlePackage.RANK_DECREASE_FOR_EXTRA_MAP_COVERAGE_REGION);
						}
					}
				}
			}

			if (bundlePackage.additionalProducts.get(device)) {
				selectedMapRegionIDs.forEach(() => bundlePackage.increaseRank(AvdbPricingBundlePackage.RANK_INCREASE_FOR_MAP_COVERAGE_REGION));
			}
		}
		bundlePackage.rank = bundlePackage.rank / numberOfDevicesCovered;
	}

	// TODO: Duplicated from BundleRecommendationComponent
	private calculateValueForBundlePackage(bundlePackage: AvdbPricingBundlePackage) {
		const values: Array<Money> = [];

		for (let bundle of Array.from(bundlePackage.bundles)) {
			const value: Money = this.getValueOfAllHighestPricedProductsIncludedInBundle(bundle);
			if (!value)
				return;
			else
				values.push(value);
		}

		for (let products of Array.from(bundlePackage.additionalProducts.values())) {
			for (let product of Array.from(products)) {
				if (!product.price)
					return;
				else
					values.push(product.price);
			}
		}

		bundlePackage.value = Money.sum(values);
	}

	// TODO: Duplicated from BundleRecommendationComponent
	private getValueOfAllHighestPricedProductsIncludedInBundle(bundle: AvdbPricingBundle): Money {
		let prices: Array<Money> = [];

		if (bundle instanceof AvdbPricingAircraftBundle) {
			for (let deviceModel of (bundle as AvdbPricingAircraftBundle).qualifyingDeviceModels) {
				for (let avdbType of deviceModel.deviceModelAvdbTypes) {
					const highestPrice: Money = this.getHighestPricedProductOption(avdbType.productOptions);
					if (!highestPrice) {
						// If we don't have complete pricing information, return null;
						return null;
					} else {
						const devices = this.allSelectedDevices.filter(device => device.modelID === deviceModel.modelID);
						devices.forEach(() => prices.push(highestPrice));
					}
				}
			}
		} else {
			for (let avdbType of (bundle as AvdbPricingDeviceBundle).avdbTypes) {
				const highestPrice: Money = this.getHighestPricedProductOption(avdbType.productOptions);
				if (!highestPrice) {
					// If we don't have complete pricing information, return null;
					return null;
				} else {
					prices.push(highestPrice);
				}
			}
		}

		return Money.sum(prices);
	}

	// TODO: Duplicated from BundleRecommendationComponent
	private getHighestPricedProductOption(productOptions: Array<string>): Money {
		let highestPrice: Money;
		for (let partKey of productOptions) {
			const product = this.partKeyProductMap.get(partKey);
			if (!product || !product.price) {
				// If we don't have complete pricing information, return null;
				return null;
			} else {
				if (!highestPrice) {
					highestPrice = product.price;
				} else if (product.price.value > highestPrice.value) {
					highestPrice = product.price;
				}
			}
		}
		return highestPrice;
	}

	// TODO: Duplicated from BundleRecommendationComponent
	getDeviceNameForBundle(bundle: AvdbPricingBundle): string {
		if (bundle instanceof AvdbPricingDeviceBundle) {
			const deviceID = (bundle as AvdbPricingDeviceBundle).deviceID;
			const device = this.allSelectedDevices.find(device => device.id === deviceID);
			return (device) ? device.name : undefined;
		} else {
			return undefined;
		}
	}

	getCoverageMessages(bundlePackage: AvdbPricingBundlePackage) {
		const messages: Array<Message> = [];

		const avdbTypes = bundlePackage.allAvdbTypes;
		const avdbTypeNames = Array.from(avdbTypes).map(t => t.name).join(", ");
		messages.push(Message.success(`Includes ${avdbTypeNames}`));

		const devicesPartiallyCovered = this.getDevicesPartiallyCoveredByBundlePackage(bundlePackage);

		// getDevicesCovered returns devices whether they have full coverage or partial coverage.
		// You can get devices fully covered by getting the difference of all covered devices and partially covered devices.
		let devicesFullyCovered = _.difference(this.getDevicesCoveredByBundlePackage(bundlePackage), devicesPartiallyCovered);
		if (devicesFullyCovered.length > 0) {
			let devicesCoveredNames = devicesFullyCovered.map(d =>
				(this.duplicateDeviceNames.has(d.name) ? d.name + ' (' + d.displaySerial + ')' : d.name)).join(", ");
			messages.push(Message.success(`Covers ${devicesCoveredNames}`));
		}

		let devicesPartiallyCoveredNames = devicesPartiallyCovered.map(d => (this.duplicateDeviceNames.has(d.name) ? d.name + ' (' + d.displaySerial + ')' : d.name)).join(", ");
		if (devicesPartiallyCoveredNames.length > 0) {
			messages.push(Message.warning(`Does not cover all selected regions for ${devicesPartiallyCoveredNames}`));
		}

		const devicesNotCovered = this.getDevicesNotCoveredByBundlePackage(bundlePackage);
		if (devicesNotCovered.length > 0) {
			let devicesNotCoveredNames = devicesNotCovered.map(d =>
				(this.duplicateDeviceNames.has(d.name) ? d.name + ' (' + d.displaySerial + ')' : d.name)).join(", ");
			messages.push(Message.warning(`Does not cover ${devicesNotCoveredNames}`));
		}

		// In this component, we only add 1 bundle to each bundle package.
		// We can grab the one bundle here, and figure out fixed-wing / helicopter eligibility.
		const bundle = Array.from(bundlePackage.bundles.values())[0];
		if (bundle instanceof AvdbPricingAircraftBundle) {
			if (!this.selectedAircraft.isRotorcraft && !bundle.fixedWingEligible && bundle.helicopterEligible) {
				messages.push(Message.warning("This bundle is intended for helicopters only"));
			}
			if (this.selectedAircraft.isRotorcraft && !bundle.helicopterEligible && bundle.fixedWingEligible) {
				messages.push(Message.warning("This bundle is intended for fixed-wing aircraft only"));
			}
		} else {
			if (this.isDeviceBundleForAnAircraftDevice(bundle as AvdbPricingDeviceBundle)) {
				if (!this.selectedAircraft.isRotorcraft && !bundle.fixedWingEligible && bundle.helicopterEligible) {
					messages.push(Message.warning("This bundle is intended for helicopters only"));
				}
				if (this.selectedAircraft.isRotorcraft && !bundle.helicopterEligible && bundle.fixedWingEligible) {
					messages.push(Message.warning("This bundle is intended for fixed-wing aircraft only"));
				}
			}
		}

		return messages;
	}

	private getDevicesCoveredByBundle(bundle: AvdbPricingBundle): Array<Device> {
		const devices = this.filteredBundleToCoveredDevicesMap.get(bundle);
		return (devices) ? devices : [];
	}

	private getDevicesCoveredByBundlePackage(bundlePackage: AvdbPricingBundlePackage): Array<Device> {
		const devicesCovered = new CustomEqualitySet<Device>();

		for (let bundle of Array.from(bundlePackage.bundles)) {
			for (let device of this.getDevicesCoveredByBundle(bundle)) {
				devicesCovered.add(device);
			}
		}

		for (let device of Array.from(bundlePackage.additionalProducts.keys())) {
			devicesCovered.add(device);
		}

		return Array.from(devicesCovered);
	}

	private getDevicesNotCoveredByBundlePackage(bundlePackage: AvdbPricingBundlePackage): Array<Device> {
		const devicesCovered = this.getDevicesCoveredByBundlePackage(bundlePackage);
		return _.difference(this.allSelectedDevices, devicesCovered);
	}

	// ====================================================================================================
	// Cart
	// ====================================================================================================

	addBundlePackageToCart(bundlePackage: AvdbPricingBundlePackage) {
		this.loadingAddToCart = true;
		let itemsToAdd: CartItem[] = [];
		for (let bundle of Array.from(bundlePackage.bundles)) {
			if (bundle instanceof AvdbPricingAircraftBundle) {
				const aircraft = this.selectedAircraft;
				const cartItem = new AvdbBundleCartItem({bundle, aircraft});
				itemsToAdd.push(cartItem);
			} else {
				const device = this.allSelectedDevices.find(d => d.id === (bundle as AvdbPricingDeviceBundle).deviceID);
				const cartItem = new AvdbBundleCartItem({bundle, device});
				itemsToAdd.push(cartItem);
			}
		}

		for (let device of Array.from(bundlePackage.additionalProducts.keys())) {
			for (let product of Array.from(bundlePackage.additionalProducts.get(device))) {
				const cartItem = new AvdbCartItem({device, product});
				itemsToAdd.push(cartItem);
			}
		}

		Observable.forkJoin(itemsToAdd.map(item => this.cartService.addItem(item))).subscribe(_ => {
			itemsToAdd.map(item => this.keepShoppingModal.addModalItem(item));
			this.loadingAddToCart = false;
			this.keepShoppingModal.open();
		});
	}

	private refreshCurrentCart() {
		this.bundleListCart = this.currentCart;
	}

	/**
	 * Returns selected devices that have coverage by the provided bundlePackage for some but not all regions selected.
	 */
	private getDevicesPartiallyCoveredByBundlePackage(bundlePackage: AvdbPricingBundlePackage): Array<Device> {
		const devicesPartiallyCovered = new CustomEqualitySet<Device>();
		const devicesFullyCovered = new CustomEqualitySet<Device>();

		for (let bundle of Array.from(bundlePackage.bundles)) {
			for (let device of this.getDevicesCoveredByBundle(bundle)) {
				if (!Array.from(this.selectedMapRegions).every((region) => bundle.isMapRegionSupported(region))) {
					devicesPartiallyCovered.add(device);
				}
			}
		}

		for (let bundle of Array.from(bundlePackage.bundles)) {
			for (let device of this.getDevicesCoveredByBundle(bundle)) {
				if (Array.from(this.selectedMapRegions).every((region) => bundle.isMapRegionSupported(region))) {
					devicesFullyCovered.add(device);
				}
			}
		}

		return _.difference(Array.from(devicesPartiallyCovered), Array.from(devicesFullyCovered));
	}

	private calculateShouldShowFliteCharts() {
		this.shouldShowFliteCharts = this.allSelectedDevices.some((device) => device.avdbTypes.some((type) => type.id == FLITECHARTS_AVDB_TYPE_ID));
	}

	updateCart() {
		this.continueShopping.emit();
		this.bundleAddedToCart.emit();
	}

	navigateToDetails(isAircraft: boolean): string {
		const devicesList = `${this.contextPath}/devices/list`;
		//Neither of these `if` statements are actually used on the page.
		// This stack is just cursed and these checks prevent NPEs which break the entire page.
		if (isAircraft && this.selectedAircraft == null) {
			return devicesList;
		}
		if (!isAircraft && this.selectedPortable == null) {
			return devicesList;
		}
		const pathToUse = (isAircraft) ? '/devices/aircraft/' : '/devices/details/';
		const idToUse = (isAircraft) ? this.selectedAircraft.id : this.selectedPortable.id;
		return `${this.contextPath}${pathToUse}${idToUse}`;
	}
}
